import { ChildConnectionFormVM } from '../child-connection-form.viewmodel';
import { ConnectionType, IChildConnectionDTO, IConnectionDetailsDTO } from '../../../../../../api/connections.dao';
import { ChildPanelistLinkFieldKey, configList } from './panelist-link-child-connection.config';


export class PanelistLinkChildConnectionVM extends ChildConnectionFormVM {
    constructor(
        accountId: number,
        eventId: number,
        childConnection: IChildConnectionDTO,
        parentConnectionDetails: IConnectionDetailsDTO,
        onChildConnectionUpdated: (childConnection: IChildConnectionDTO, parentConnectionId: number) => void
    ) {
        super(accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated);
        this.initFormDataCtrl(configList, childConnection);
    }

    public get type(): ConnectionType { return ConnectionType.PanelistLink; }

    public async updateChildConnection(): Promise<boolean> {
        return super.updateChildConnection(this.composeUpdateChildConnectionDetails());
    }

    private composeUpdateChildConnectionDetails(): Partial<IChildConnectionDTO> {
        return {
            type: this.type,
            connectionLink: this.formDataCtrl.getValue(ChildPanelistLinkFieldKey.CONNECTION_LINK) as string,
            joinMethodId: this.childConnection.joinMethodId,
            parentJoinMethodId: this.parentConnectionDetails.joinMethodId,
            label: this.formDataCtrl.getValue(ChildPanelistLinkFieldKey.LABEL) as string,
            attendeeEmail: this.formDataCtrl.getValue(ChildPanelistLinkFieldKey.ATTENDEE_EMAIL) as string,
            connectionPassword: this.formDataCtrl.getValue(ChildPanelistLinkFieldKey.CONNECTION_PASSWORD) as string,
            connectionAccount: this.formDataCtrl.getValue(ChildPanelistLinkFieldKey.CONNECTION_ACCOUNT) as string,
            participantId: this.formDataCtrl.getValue(ChildPanelistLinkFieldKey.PARTICIPANT_ID) as string,
        };
    }
}